import * as React from 'react'
import { SystemLink } from '../tools/SystemLink'
export const SystemNavToggle = () => {

    const handleClick = () => {
        if (document.body.classList.contains("sidebar-collapse")) {
            document.body.classList.remove("sidebar-collapse");
        }
        else {
            document.body.classList.add("sidebar-collapse");
        }
    }
    return (
        <div>
            <SystemLink handleClick={handleClick} to="#" data-toggle="push-menu" className="paper-nav-toggle pp-nav-toggle">
                <i></i>
            </SystemLink >
        </div>
    )
}
